import "core-js/modules/web.dom-collections.iterator.js";
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);
  return {
    source: sourceClone,
    destination: destClone
  };
};

// droppableIdCollectionMap example = {"droppableId": collection, "droppableId2": collection2, ...}
// returns a hashmap of new collections ordered {"droppableId": collection, ...  or false if it fails
const dragEndNewCollectionMap = (result, droppableIdCollectionMap) => {
  const {
    source,
    destination
  } = result;

  //console.log("result", result, droppableIdCollectionMap)
  if (!destination) {
    // dropped outside the list
    return false;
  }
  let newCollectionMap = {};
  if (source.droppableId === destination.droppableId) {
    let droppableId = source.droppableId;
    const collection = droppableIdCollectionMap[droppableId];
    if (!Boolean(collection)) {
      console.error("droppableIdCollectionMap invalid", droppableId, droppableIdCollectionMap);
      return false;
    }
    const newCollection = reorder(collection, source.index, destination.index);
    newCollectionMap[droppableId] = newCollection;
  } else {
    //different destination

    const collectionSource = droppableIdCollectionMap[source.droppableId];
    if (!Boolean(collectionSource)) {
      console.error("droppableIdCollectionMap invalid", source.droppableId, droppableIdCollectionMap);
      return false;
    }
    const collectionDestination = droppableIdCollectionMap[destination.droppableId];
    if (!Boolean(collectionDestination)) {
      console.error("droppableIdCollectionMap invalid", destination.droppableId, droppableIdCollectionMap);
      return false;
    }
    const moveResult = move(collectionSource, collectionDestination, source, destination);
    newCollectionMap[source.droppableId] = moveResult.source;
    newCollectionMap[destination.droppableId] = moveResult.destination;
  }
  return newCollectionMap;
};
export default dragEndNewCollectionMap;